<template>
  <div class="banner" :style="{ 'background-image': `url(${url})` }">
    <!-- <img class="banner-img" :src="url" fetchpriority="high" /> -->
    <slot name="content"></slot>
  </div>
</template>
<script setup lang="ts">
import { environmentData } from '@support/utils';
// import img from '@/assets/images/pc-index.jpg';
// import imgCn from '@/assets/images/pc-index-cn.jpg';
const img = 'https://oms-oss-public.ninebot.com/website/support/pc-index.jpg';
const imgCn =
  'https://oms-oss-public.ninebot.com/website/support/pc-index-cn.jpg';

defineProps({
  url: {
    type: String,
    default: () => (environmentData.country == 'cn' ? imgCn : img)
  }
});
</script>
<style lang="scss" scoped>
.banner {
  width: 100%;
  min-width: 1200px;
  // height: 400px;
  height: 22.22vw;
  position: relative;
  z-index: 99;
  background-position: 50%;
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: scroll;
  .banner-img {
    width: 100%;
  }
}
</style>
